var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabEvents = function SvgTabEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4a1 1 0 0 0 2 0V2a1 1 0 0 0-2 0M6 2v4a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0M3 12h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M19.5 3A2.5 2.5 0 0 1 22 5.5v15a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 20.5v-15A2.5 2.5 0 0 1 4.5 3zm0 2h-15a.5.5 0 0 0-.5.5v15c0 .28.22.5.5.5h15a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5"
  }))));
};
export default SvgTabEvents;